/**
 * Longevity Health Institute tenant configuration (PROD-568, Profile B).
 *
 * Source: master Pre-flight Decisions Tenant Profile Names + Multi-Clinic
 * Divergence Mechanism. Longevity is the FM/longevity clinic; the source
 * library is Functional Medicine plus the longevity-aligned guidelines (EAS,
 * AACE longevity, Attia-aligned reference set) and the priority weighting is
 * clinical depth (root-cause + multi-modal workup).
 *
 * Source library tags use the year-versioned form where the canonical
 * source has one (PATHWAY-PRD TENANT-4 amended in the 2026-05-05 fixer
 * round). `IFM`, `AACE-longevity`, and `Attia-aligned` are not
 * year-versioned because the canonical reference sets are continually
 * updated rather than published as a discrete year-stamped guideline.
 *
 * Per ADR-PROTO-002 the display string is a synthetic placeholder; the
 * `DEMO TENANT - SYNTHETIC CONFIGURATION` footer carries the warning.
 */
import type { TenantConfig } from './types';

export const longevityHealthInstitute: TenantConfig = {
  id: 'longevity-health-institute',
  displayName: 'Longevity Health Institute',
  defaultProtocol: 'cardiometabolic-pathway',
  sourceLibraryTags: ['IFM', 'EAS2022', 'AACE-longevity', 'Attia-aligned'],
  clinicalPriorityWeighting: 'clinical-depth',
  nbaFrequency: 'higher',
};
